import { motion } from "framer-motion";
import { TESTIMONIALS } from "@/lib/site";
import { TrendingUp } from "lucide-react";

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="relative py-20 md:py-28">
      <div className="max-w-[1160px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="chip mb-5">
            <span className="dot" /> Clínicas que ya cambiaron
          </span>
          <h2 className="font-display text-3xl md:text-5xl lg:text-[56px] font-bold text-[#0B0B14] tracking-tight leading-[1.05] max-w-3xl mx-auto">
            Ya no comparan marcas. <span className="text-[#5A48C9]">Comparan proveedores.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {TESTIMONIALS.map((t, i) => (
            <motion.article
              key={t.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.1 }}
              data-testid={`testimonial-${i}`}
              className={`p-7 md:p-8 flex flex-col ${
                t.highlight ? "card-glass md:-mt-6 md:mb-6" : "card-soft"
              }`}
            >
              <p className="text-[11px] font-semibold uppercase tracking-widest text-[#5A48C9] mb-5">
                {t.tag}
              </p>
              <blockquote className="font-display text-lg md:text-xl font-medium text-[#0B0B14] leading-snug tracking-tight flex-1">
                “{t.quote}”
              </blockquote>

              {t.metric && (
                <div className="mt-6 flex items-center gap-2 rounded-full bg-white/80 border border-black/[0.06] px-3 py-2 backdrop-blur w-fit">
                  <TrendingUp className="w-3.5 h-3.5 text-[#5A48C9]" strokeWidth={2} />
                  <span className="text-[12px] font-semibold text-[#0B0B14]">{t.metric}</span>
                </div>
              )}

              <div className="mt-6 flex items-center gap-3 pt-6 border-t border-black/[0.06]">
                <img
                  src={t.avatar}
                  alt={t.name}
                  loading="lazy"
                  className="w-10 h-10 rounded-full object-cover ring-2 ring-white"
                />
                <div>
                  <p className="text-sm font-bold text-[#0B0B14]">{t.name}</p>
                  <p className="text-[11px] text-[#6B6B7D] font-medium">{t.role}</p>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
